import { render, staticRenderFns } from "./EditarReceta.vue?vue&type=template&id=d5281dda&scoped=true"
import script from "./EditarReceta.vue?vue&type=script&lang=js"
export * from "./EditarReceta.vue?vue&type=script&lang=js"
import style0 from "./EditarReceta.vue?vue&type=style&index=0&id=d5281dda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5281dda",
  null
  
)

export default component.exports